import { FLUCTUATED_TYPE } from 'constants/Enums';
import { PRICE_DECREASE_ICON, PRICE_INCREASE_ICON } from 'constants/Icons';
import Image from 'next/image';

const ICON_SIZE = {
  [FLUCTUATED_TYPE.INCREASED]: { src: PRICE_INCREASE_ICON, width: 18, height: 18 },
  [FLUCTUATED_TYPE.DECREASED]: { src: PRICE_DECREASE_ICON, width: 16, height: 16 },
};

const FluctuatedPriceIcon = ({ fluctuatedType }) => {
  const icon = ICON_SIZE[fluctuatedType];
  if (!icon) return null;

  return (
    <Image
      src={icon.src}
      width={icon.width}
      height={icon.height}
      layout="fixed"
      alt={fluctuatedType === FLUCTUATED_TYPE.INCREASED ? 'price increased' : 'price decreased'}
    />
  );
};

export default FluctuatedPriceIcon;
